<template>
    <main class="page-a">
        <section class="hero">
            <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2">
                <div class="info-container tw-flex tw-flex-col tw-items-start lg:tw-items-start tw-justify-start lg:tw-justify-start">
                    <div class="logo">
                        <img src="~@/assets/img/logo.svg"/>
                    </div>
                    <h1 class="title tw-mb-5 tw-block lg:tw-mb-12">SEGURO DE SAÚDE ANIMAL</h1>
                    <div class="info tw-w-full">
                        <h2 class="tw-uppercase">
                            Receba Até 250€* em vouchers
                        </h2>
                        <h3>
                            + 25€ em serviços fixo.pt
                        </h3>
                    </div>
                </div>
                <div class="form-container">
                    <div class="form-icon tw-opacity-0 lg:tw-opacity-100">
                        <img src="~@/assets/img/icons/form-icon.svg"/>
                    </div>
                    <h1 v-if="!$store.state.formError && !$store.state.formSuccess">PEÇA A SUA SIMULAÇÃO</h1>
                    <Form v-if="!$store.state.formSuccess && !$store.state.formError" />
                    <FormSuccess v-if="$store.state.formSuccess && !$store.state.formError" />
                    <FormError v-if="$store.state.formError && !$store.state.formSuccess" />
                </div>
            </div>
        </section>
        <section class="fixo tw-py-16 lg:tw-py-20">
            <div class="tw-container">
                <h1 class="tw-text-center"> serviços Fixo.pt</h1>
                <h3 class="tw-text-center lg:tw-text-xl tw-font-bold mt-2 tw-mb-16">Descubra todos os serviços disponíveis no FIXO para que tenha mais tempo livre para si.</h3>

                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-8 lg:tw-gap-4 bullets-fixo">
                    <div class="bullet">
                        <div class="badge">
                            oferta
                            <strong>25€</strong>
                        </div>
                        <img src="~@/assets/img/casa.svg" alt="">
                        <h4>Casa</h4>
                        <p>Engomaria e Lavandaria</p>
                        <p>Remodelação e Decoração</p>
                        <p>Limpeza</p>
                        <p>Instalação e Reparação</p>
                        <p>Jardinagem</p>
                    </div>
                    <div class="bullet">
                         <div class="badge">
                            oferta
                            <strong>25€</strong>
                        </div>
                        <img src="~@/assets/img/animais.svg" alt="">
                        <h4>Animais</h4>
                        <p>Banho a cães</p>
                        <p>Tosquia a cães</p>
                    </div>
                    <div class="bullet">
                         <div class="badge">
                            oferta
                            <strong>25€</strong>
                        </div>
                        <img src="~@/assets/img/bemestar.svg" alt="">
                        <h4>Bem-estar</h4>
                        <p>Massagem</p>
                        <p>Manicure</p>
                        <p>Pedicure</p>
                        <p>Nutricionista</p>
                        <p>Personal Trainer</p>
                    </div>
                    <div class="bullet">
                         <div class="badge">
                            oferta
                            <strong>25€</strong>
                        </div>
                        <img src="~@/assets/img/empresas.svg" alt="">
                        <h4>Empresas</h4>
                        <p>Limpeza de escritórios</p>
                        <p>Limpezas de bares</p>
                        <p>Limpeza de restaurantes</p>
                    </div>
                </div>
                <button class="btn-cta tw-mx-auto tw-block mt-5" v-scroll-to="'.hero'">RECEBER 25€ OFERTA</button>
            </div>
        </section>
        <section class="bullets-grid">
            <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2">
                <div>
                    <h1>FIDELIDADE PETS</h1>
                    <h2>Ajudamos a cuidar do seu melhor amigo</h2>
                    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3 lg:tw-gap-12 tw-mx-auto lg:tw-mx-0">
                        <div>
                            <img src="~@/assets/img/icons/1.svg"/>
                            <p>Check-up sem <br class="tw-hidden lg:tw-block"/>custos adicionais<sup>(2)</sup></p>
                        </div>
                        <div>
                            <img src="~@/assets/img/icons/2.svg"/>
                            <p>Sem idade limite <br class="tw-hidden lg:tw-block"/>de permanência</p>
                        </div>
                        <div>
                            <img src="~@/assets/img/icons/3.svg"/>
                            <p>consultas por videochamada <br class="tw-hidden lg:tw-block"/>com médicos veterinários</p>
                        </div>
                        <div>
                            <img src="~@/assets/img/icons/4.svg"/>
                            <p>Esterilização <br class="tw-hidden lg:tw-block"/>e Vacinas</p>
                        </div>
                        <div>
                            <img src="~@/assets/img/icons/5.svg"/>
                            <p>Pode continuar <br class="tw-hidden lg:tw-block"/>no mesmo veterinário</p>
                        </div>
                        <div>
                            <img src="~@/assets/img/icons/6.svg"/>
                            <p>Participação <br class="tw-hidden lg:tw-block"/>de sinistros online</p>
                        </div>
                    </div>
                </div>
                <div>
                    <img src="~@/assets/img/banner-pets.png"/>
                </div>
            </div>
        </section>
        <section class="request">
            <div class="tw-container">
                <h2>Aproveite <span>70% de reembolso</span> em despesas<sup>(1)</sup></h2>
                <h3>SAIBA QUAL O <b>SEGURO MAIS ADEQUADO</b> PARA O SEU ANIMAL DE COMPANHIA!</h3>
                <button class="btn-cta tw-mx-auto tw-block" v-scroll-to="'.hero'">Pedir Simulação</button>
            </div>
        </section>
        <footer>
            <div class="tw-container tw-flex tw-items-center tw-justify-center tw-flex-col">
                <img src="~@/assets/img/logo_footer.svg" class="tw-mb-4">
                <p class="tw-mb-4"><b>Copyright © {{new Date().getFullYear()}} Fidelidade. Todos os direitos reservados.</b></p>
                <p>
                    *Oferta voucher até 250€ válida na subscrição dos Planos Pet 2, Pet 3 e Pet Vital entre 1 agosto e 31 outubro 2024, limitada ao stock existente de 5758 vouchers. Consulte aqui as condições da oferta de 25€ de desconto em serviços FIXO.
                    <br>
                    (1) Até ao limite do capital contratado para cada cobertura. <br>
                    (2) Consulta de observação e exames nas condições em vigor. <br>
                    Esta informação não dispensa a consulta da informação pré-contratual e contratual legalmente exigida.
                </p>
                <p>Fidelidade - Companhia de Seguros, S.A. - NIPC e Matrícula 500 918 880, na CRC Lisboa - Sede: Largo do Calhariz, 30 1249-001 Lisboa – Portugal - Capital Social EUR 509.263.524</p>
                <p>Apoio ao Cliente: Dias úteis das 9h às 20h. Telefone: 217 948 701 - Chamada para a rede fixa nacional. Email: <a href="mailto:apoiocliente@fidelidade.pt">apoiocliente@fidelidade.pt</a>. <a href="https://www.fidelidade.pt" target="_blank">www.fidelidade.pt</a></p>
            </div>
        </footer>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';
import FormError from '@/components/FormError.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
        FormError,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
@import '~@/assets/scss/partials/_fonts.scss';

main {

    section {

        &.hero {

            @screen lg {
                height: 850px;
            }

            .info-container {
                @apply tw-relative tw-bg-no-repeat tw-bg-cover tw-bg-center;
                padding: 17.5px 16px 17px 16px;
                background-image: url('~@/assets/img/hero-mobile.jpg');
                height: 210px;

                @screen lg {
                    @apply tw-bg-center;
                    background-image: url('~@/assets/img/hero-desktop.jpg');
                    height: auto;
                }

                @screen lg {
                    padding: 30px 55px 72px 55px;
                    height: 850px;
                }

                @screen xl {
                    padding: 50px 100px 72px 100px;
                }

                .logo {

                    >img {
                        @apply tw-pointer-events-none;
                        width: 150px;

                        @screen lg {
                            width: 281.3px;
                        }
                    }
                }

                h1 {
                    @apply tw-font-bold tw-mt-2;
                    font-family: $font_title;
                    font-size: 13px;
                    line-height: 16px;
                    color: #fff;

                    @screen lg {
                        font-size: 30px;
                        line-height: 37px;
                    }
                }

                h2 {
                    @apply tw-font-bold;
                    color: #fff !important;
                    font-family: $font_title;
                    font-size: 36px;
                    line-height: 33px;

                    @screen lg {
                        font-size: 80px;
                        line-height: 73px;
                    }
                }

                .info {
                    @apply tw-pt-2;
                    @screen lg {
                        padding-top: 200px;
                    }

                    h2{
                        @apply tw-uppercase tw-text-left tw-mb-0;
                        color: #fff;
                        font-size: 40px;
                        line-height: 40px;

                        @screen lg {
                            @apply tw-pb-5;
                            font-size: 100px;
                            line-height: 102px;
                            max-width: 600px;
                        }
                    }

                    h3 {
                        @apply tw-text-left tw-pb-4 tw-font-bold tw-uppercase;
                        color: #fff;
                        font-size: 30px;
                        line-height: 32px;
                        font-family: $font_title;

                        @screen lg {
                            @apply tw-pb-5;
                            font-size: 60px;
                            line-height: 60px;
                        }
                    }

                    >img {
                        @apply tw-pointer-events-none;
                        width: 212.02px;
                        padding-top: 15px;

                        @screen lg {
                            padding-top: 72px;
                            width: 244.14px;
                        }
                    }
                }
            }

            .form-container {
                @apply tw-relative;
                background-color: $main_color;
                padding: 40px 16px 17px 16px;

                @screen lg {
                    padding: 65px 55px 72px 55px;
                    height: 850px;
                }

                @screen xl {
                    padding: 65px 100px 72px 100px;
                }

                .form-icon {
                    @apply tw-absolute tw-top-0;
                    left: 50%;
                    transform: translateX(-50%);

                    >img {
                        @apply tw-pointer-events-none;
                        width: 78px;
                        height: 39px;

                        @screen lg {
                            width: 119px;
                            height: 60px;
                        }
                    }
                }

                h1 {
                    @apply tw-font-bold tw-uppercase tw-text-white tw-text-center tw-mx-auto;
                    font-family: $font_title;
                    font-size: 26px;
                    width: 100%;

                    @screen lg {
                        font-size: 48px;
                        padding-bottom: 10px;
                        min-width: 400px;
                    }
                }
            }
        }

        &.fixo{
            background-color: #EFEFEF;

            h1 {
                @apply tw-font-bold tw-text-center tw-uppercase;
                font-family: $font_title;
                color: $main_color;
                font-size: 34px;

                @screen lg {
                    font-size: 60px;
                    line-height: 72px;
                }
            }
            .bullets-fixo{
                .bullet{
                    @apply tw-bg-white tw-rounded-lg tw-shadow tw-text-center tw-pt-4 tw-pb-8 tw-flex tw-flex-col tw-items-center tw-relative;

                    .badge{
                        @apply tw-text-white tw-absolute tw-right-0 tw-top-0 tw-transform tw--translate-x-2 tw--translate-y-6 tw-flex tw-flex-col tw-uppercase tw-items-center tw-justify-center;
                        background-color: #e52431;
                        line-height: 1;
                        border-radius: 100%;
                        width: 74px;
                        height: 74px;
                        font-family: $font_title;

                        strong{
                            font-size: 40px;
                            margin: 0;
                            padding: 0;
                            line-height: 1;
                        }
                    }
                    h4{
                        @apply tw-text-xl tw-font-bold;
                    }
                    p{
                        line-height: 28px;
                    }
                }
            }
            .btn-cta{
                max-width: 300px;
                margin-top: 50px;
            }
        }

        &.bullets-grid {
            padding: 42.5px 0 42.5px 20px;

            @screen lg {
                padding: 120px 0 120px 100px;
            }

            .tw-grid {
                @apply tw-mx-auto tw-relative;

                div {

                    h1 {
                        @apply tw-font-bold tw-text-center tw-uppercase;
                        font-family: $font_title;
                        color: $main_color;
                        font-size: 34px;

                        @screen lg {
                            @apply tw-text-left;
                            font-size: 60px;
                            line-height: 72px;
                        }
                    }

                    h2 {
                        @apply tw-font-bold tw-text-xl tw-text-center tw-uppercase;
                        font-family: $font_title;
                        color: $text;
                        margin-bottom: 36px;

                        @screen lg {
                            @apply tw-text-left;
                            font-size: 36px;
                            line-height: 42px;
                            margin-bottom: 76px;
                        }
                    }

                    .tw-grid {
                        @apply tw-mx-auto;
                        width: fit-content;

                        @screen lg {
                            width: auto;
                            @apply tw-mx-0;
                        }

                        >div {
                            @apply tw-flex tw-gap-3 tw-items-center;

                            img {
                                @apply tw-pointer-events-none;
                                width: 44px;
                                height: 44px;

                                @screen lg {
                                    width: 60px;
                                    height: 60px;
                                }
                            }

                            p {
                                @apply tw-font-normal tw-uppercase tw-text-lg;
                                font-family: $font_title;

                                @screen lg {
                                    font-size: 24px;
                                    line-height: 35px;
                                }
                            }
                        }
                    }

                    >img {
                        @apply tw-pointer-events-none;
                        width: 100%;
                        float: none;

                        @screen md {
                            margin-top: 10px;
                            float: right;
                            width: 72.5%;
                        }

                        @screen lg {
                            width: 100%;
                        }
                    }

                    .badge {
                        @apply tw-absolute;
                        width: 84.59px;
                        height: 99.16px;
                        top: auto;
                        bottom: 200px;
                        right: 20px;

                        @screen sm {
                            bottom: 420px;
                            right: 20px;
                        }

                        @screen lg {
                            right: 50px;
                            width: 100px;
                            height: 122.4px;
                            bottom: auto;
                            top: -50px;
                        }

                        @screen xl {
                            right: 100px;
                            width: 130px;
                            height: 152.4px;
                            top: -20px;
                        }

                        >img {
                            @apply tw-pointer-events-none tw-w-full tw-h-full;
                        }
                    }
                }
            }
        }

        &.request {
            background-color: $grey;
            padding: 47.5px 0;

            @screen lg {
                padding: 81.5px 0;
            }

            .tw-container {

                h2 {
                    @apply tw-text-center tw-font-bold tw-mx-auto tw-uppercase;
                    font-family: $font_title;
                    color: $text;
                    font-size: 26px;
                    line-height: 32px;
                    margin-bottom: 20px;
                    max-width: 286px;

                    span {
                        color: $main_color;
                    }

                    @screen lg {
                        font-size: 44px;
                        line-height: 53px;
                        margin-bottom: 0px;
                        max-width: none;
                    }
                }

                h3 {
                    @apply tw-uppercase tw-text-center tw-block tw-mx-auto;
                    color: $text;
                    font-family: $font_title;
                    max-width: 266px;
                    font-size: 20px;
                    margin-bottom: 20px;

                    @screen lg {
                        margin-bottom: 30px;
                        font-size: 30px;
                        max-width: none;
                    }
                }

                >button {
                    width: 260px !important;

                    @screen lg {
                        width: 300px !important;
                    }
                }
            }
        }
    }

    footer {
        @apply tw-py-12 tw-text-center;

        @screen lg {
            @apply tw-py-12;
        }

        .tw-container {

            img {
                width: 210px;
            }

            p {
                @apply tw-pb-3 tw-text-xs;

                span {
                    color: $text;

                    a {

                        &:hover {
                            @apply tw-underline;
                        }
                    }
                }
            }
        }
    }
}

</style>
